import type { GroupSummary, ManagedUser } from "../types";
import { escapeHtml } from "../view-helpers";

function renderGroupSelect(groups: GroupSummary[], targetInputId: string): string {
  if (!groups.length) {
    return "";
  }
  return `
    <label class="field">
      <span>已有小组</span>
      <select class="select-field" data-action="copy-group-option" data-target-input="${targetInputId}">
        <option value="">从已有小组中选择</option>
        ${groups
          .map(
            (group) => `
              <option value="${escapeHtml(group.name)}">${escapeHtml(group.name)}</option>
            `,
          )
          .join("")}
      </select>
    </label>
  `;
}

function renderUserRow(user: ManagedUser, groups: GroupSummary[]): string {
  const inputId = `managed-user-group-${user.id}`;
  return `
    <div class="panel user-row">
      <div class="stack">
        <strong>${escapeHtml(user.name)}</strong>
        <p class="muted">小组：${escapeHtml(user.groupName)}</p>
        <p class="mini-meta">创建时间：${new Date(user.createdAt).toLocaleString("zh-CN")}</p>
        <div class="stack compact-stack">
          <div class="field">
            <span>调整分组</span>
            <input
              id="${inputId}"
              name="groupName"
              type="text"
              value="${escapeHtml(user.groupName)}"
              placeholder="输入新的小组名称"
              maxlength="24"
              autocomplete="off"
              data-user-group-input="${user.id}"
            />
          </div>
          ${renderGroupSelect(groups, inputId)}
          <div class="inline-actions">
            <button
              class="ghost-button small-button"
              type="button"
              data-action="save-managed-user-group"
              data-user-id="${user.id}"
              data-user-name="${escapeHtml(user.name)}"
            >
              保存分组
            </button>
            <button
              class="ghost-button small-button"
              type="button"
              data-action="delete-managed-user"
              data-user-id="${user.id}"
              data-user-name="${escapeHtml(user.name)}"
            >
              删除
            </button>
          </div>
        </div>
      </div>
    </div>
  `;
}

export function renderAdminUsersPage(users: ManagedUser[], groups: GroupSummary[]): string {
  return `
    <section class="screen">
      <header class="topbar">
        <button class="ghost-button" data-action="back-to-projects">返回项目列表</button>
        <h1>用户管理</h1>
      </header>
      <div class="panel stack">
        <div>
          <p class="eyebrow">管理员操作</p>
          <h2>新增小组</h2>
          <p class="muted">先建小组，再给用户或项目选择这个小组。</p>
        </div>
        <form id="admin-group-form" class="stack">
          <div class="field">
            <span>小组名称</span>
            <input name="groupName" type="text" placeholder="例如：一组" maxlength="24" autocomplete="off" required />
          </div>
          <button class="primary-button" type="submit">确认新增小组</button>
        </form>
        <div class="inline-pills">
          ${groups.map((group) => `<span class="state-pill">${escapeHtml(group.name)}</span>`).join("")}
        </div>
        <p id="admin-group-status" class="mini-meta"></p>
      </div>
      <div class="panel stack">
        <div>
          <p class="eyebrow">管理员操作</p>
          <h2>新增普通用户</h2>
          <p class="muted">姓名、密码、小组都在这里维护。小组可直接输入新名称，也可复用已有分组。</p>
        </div>
        <form id="admin-user-form" class="stack">
          <label class="field">
            <span>姓名</span>
            <input name="name" type="text" placeholder="请输入用户姓名" maxlength="24" required />
          </label>
          <label class="field">
            <span>密码</span>
            <input name="password" type="password" placeholder="请输入用户密码" maxlength="32" required />
          </label>
          <div class="field">
            <span>小组名称</span>
            <input id="admin-user-group-input" name="groupName" type="text" placeholder="输入新小组名称" maxlength="24" autocomplete="off" required />
          </div>
          ${renderGroupSelect(groups, "admin-user-group-input")}
          <button class="primary-button" type="submit">确认添加用户</button>
        </form>
        <p id="admin-user-status" class="mini-meta"></p>
      </div>
      <div class="panel stack">
        <div class="inline-head">
          <div>
            <h2>现有用户</h2>
            <p class="muted">管理员可在这里直接调整人员分组，删除用户前也会再次确认。</p>
          </div>
          <span class="state-pill">${users.length} 个用户</span>
        </div>
        ${users.length ? users.map((user) => renderUserRow(user, groups)).join("") : `<p class="muted">还没有普通用户，先新增一个。</p>`}
      </div>
    </section>
  `;
}
